import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  logViewController: [
    'runtimeConstant',
    '$scope',
    'dashboardService',
    '$filter',
    'ELogType',
    function (runtimeConstant, $scope, dashboardService, $filter, ELogType) {
      'use strict';

      function dateLimit() {
        $scope.data = {};
        $scope.data.startDate = new Date();

        return ($scope.options = {
          minDate: new Date(),
        });
      }

      function orderFilter(value) {
        value.sort(function (a, b) {
          var nameA = $filter('translate')(a.Name);
          var nameB = $filter('translate')(b.Name);
          return nameA > nameB ? 1 : nameB > nameA ? -1 : 0;
        });
      }

      function selectedUsers(value) {
        if (arguments.length === 0) return $scope.selectedUser;
        $scope.selectedUser = value;
      }

      function selectedActions(value) {
        if (arguments.length === 0) return $scope.selectedAction;
        $scope.selectedAction = value;
      }

      function loadType() {
        for (let index = 0; index < Object.keys(ELogType).length; index++) {
          $scope.actions.push({
            Name: Object.keys(ELogType)[index],
            Id: ELogType[Object.keys(ELogType)[index]],
          });
        }
        $scope.orderFilter($scope.actions);
      }

      function loadUsers() {
        dashboardService.getUsersFilter().then((data) => {
          $scope.users = data;
          $scope.orderFilter($scope.users);
        });
      }

      function saveAsPdf() {
        var filter = {};
        filter.reportType = 8;
        filter.NoDate = true;
        filter.dateFilterType = 3;
        filter.EmptyLogType = true;

        if ($scope.selectedAction !== null) {
          filter.FilterType = $filter('translate')($scope.selectedAction.Name);
          filter.ELogType = $scope.selectedAction.Id;
          filter.EmptyLogType = false;
        } else {
          filter.FilterType = $filter('translate')('NO FILTER');
        }

        if ($scope.selectedUser !== null)
          filter.IdUser = $scope.selectedUser.Id;
        filter.UserName = $scope.selectedUser.Name;

        filter.StartDate = $scope.newForm.startDate.$modelValue;
        filter.EndDate = $scope.newForm.endDate.$modelValue;

        if ($scope.startDate !== null || $scope.endDate !== null) {
          filter.NoDate = false;
        }

        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
        });

        $scope.filter = filter;

        dashboardService
          .generateLogViewReport($scope.filter)
          .then((res) => {
            if (res.size !== 0) {
              var url = URL.createObjectURL(res);
              window.open(url);
              swal.close();
            } else {
              swal.fire({
                title: 'Relatório em branco',
                text: 'Não existem dados para serem exibidos neste relatório com os filtros selecionados.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          })
          .catch((error) => {
            swal.fire({
              title:
                error.code === 422 ? error.title : 'Limite de dias excedidos',
              text:
                error.code === 422
                  ? error.text
                  : 'A busca entre datas está restrita ao máximo de 31 dias.',
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function run() {
        try {
          $scope.filter;
          $scope.userLog = [];
          $scope.user;
          $scope.users;
          $scope.selectedUsers;
          $scope.selectedUser;
          $scope.startDate;
          $scope.endDate;
          $scope.action;
          $scope.actions = [];
          $scope.selectedActions;
          $scope.selectedAction;

          $scope.dateLimit = logWrapper(
            dateLimit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.orderFilter = logWrapper(
            orderFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedUsers = logWrapper(
            selectedUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedActions = logWrapper(
            selectedActions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadType = logWrapper(
            loadType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadUsers = logWrapper(
            loadUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveAsPdf = logWrapper(
            saveAsPdf,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.loadUsers();
          $scope.loadType();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
